import Vue from 'vue';
import Buefy from 'buefy';
import moment from 'moment';
import App from './App.vue';
import router from './router';
import store from './store/store';
import './assets/scss/app.scss';
import * as translate from './i18n/translate';
import initTranslate from './i18n/serviceTranslate';
import i18n from './i18n';
import gestionErreur from '@/services/general/gestionErreur';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import { dateParser, LISTE_JOURS, LISTE_MOIS, JOUR_DEBUT_SEMAINE } from './configuration/datePickerConf';
import { CLE_GOOGLE_API } from './configuration/configurationCarte';
import JsonCSV from "vue-json-csv";

Vue.use(Buefy, {
  defaultIconPack: 'mdi',
  defaultContainerElement: '#content',
  defaultDayNames: LISTE_JOURS,
  defaultMonthNames: LISTE_MOIS,
  defaultFirstDayOfWeek: JOUR_DEBUT_SEMAINE,
  defaultDateParser: date => dateParser(date),
  defaultDateFormatter: date => {
    if (date.length) return `Du ${moment(date[0]).format('DD/MM/YYYY')} au ${moment(date[1]).format('DD/MM/YYYY')}`;
    return moment(date).format('DD/MM/YYYY');
  },
});


Vue.use(VueGoogleMaps, {
  load: {
    key: CLE_GOOGLE_API,
    libraries: 'places',
  },
});
Vue.component('GmapCluster', GmapCluster);
Vue.component('downloadCsv', JsonCSV);

Vue.config.productionTip = false;

const messages = translate.TRANSLATE;
if (process.env.NODE_ENV === 'development') {
  initTranslate(messages.fr);
}

Vue.config.errorHandler = (e) => {
  gestionErreur('Erreur interne à l\'application', e);
  throw e;
};
window.onerror = (message, source, line, column, e) => {
  gestionErreur('Erreur interne à l\'application', e);
  throw e;
};

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
